import {
  ConfigCredentialsInput,
  ConfigCredentialsResponse,
  HasCredentialsInput,
  DeleteCredentialsInput,
  DeleteCredentialsResponse,
  AddressInfoSearchInput,
  AddressInfoSearchResponse,
  SanctionSearchInput,
  SanctionSearchResponse,
  IntegrationIDs,
} from "~/endpoints/integrations";
import {
  deleteThroughAuthProxy,
  getThroughAuthProxy,
  postThroughAuthProxy,
  putThroughAuthProxy,
} from "~/endpoints/utils";

export const configCredentials = async (
  params: { vaspDID: string; integrationId: IntegrationIDs } & ConfigCredentialsInput,
): Promise<ConfigCredentialsResponse> => {
  const payload = {
    data: params.data,
  };

  return putThroughAuthProxy(
    `integrations/${params.integrationId.toLowerCase()}/credentials?vaspDID=${params.vaspDID}`,
    {
      payload,
    },
  );
};

export const hasCredentials = async (params: HasCredentialsInput): Promise<boolean> => {
  const response = await getThroughAuthProxy(
    `integrations/${params.integrationId.toLowerCase()}/credentials?vaspDID=${params.vaspDID}`,
  );
  return response.hasApiCredentials ? true : false;
};

export const deleteCredentials = async (params: DeleteCredentialsInput): Promise<DeleteCredentialsResponse> => {
  return deleteThroughAuthProxy(
    `integrations/${params.integrationId.toLowerCase()}/credentials?vaspDID=${params.vaspDID}`,
  );
};

export const addressInfoSearch = async (params: AddressInfoSearchInput): Promise<AddressInfoSearchResponse> => {
  const payload = {
    vaspDID: params.vaspDID,
    data: params.data,
  };

  return postThroughAuthProxy(`integrations/${params.integrationId.toLowerCase()}/addressinfo`, { payload });
};

export const sanctionSearch = async (params: SanctionSearchInput): Promise<SanctionSearchResponse> => {
  const payload = {
    vaspDID: params.vaspDID,
    data: params.data,
  };

  return postThroughAuthProxy(`integrations/${params.integrationId.toLowerCase()}/sanctions`, { payload });
};
